export type ENV = "dev" | "prod" | "demo";

export const env: ENV = "dev";

// Staging builds run with env = "dev", so this default must stay the staging
// API. For a local backend, set VITE_API_URL in .env.local (untracked) —
// never hardcode a localhost URL here.
const API_DEV_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ||
  "https://staging.scanifood.com";
const API_DEMO_URL = "https://staging.scanifood.com";
const API_PROD_URL = "https://api.scanifood.com";

const APP_STAGING_URL = "https://staging-app.scanifood.com";
const APP_PROD_URL = "https://app.scanifood.com";

function processApiUrl() {
  if (env === "prod") return API_PROD_URL;
  if (env === "demo") return API_DEMO_URL;
  return API_DEV_URL;
}

// The app's own public URL per env, sent as X-Origin on login when env is not
// "dev". Only prod is the production app; dev and demo builds are staging.
export function appBaseUrlFor(environment: ENV): string {
  return environment === "prod" ? APP_PROD_URL : APP_STAGING_URL;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = appBaseUrlFor(env);
